var _rect, _rect2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpaceThumbnailContrast = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "white",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-background-item",
    cx: 90.6572,
    cy: 22,
    r: 3.5,
    fill: "#1E1E1E",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-background-item",
    cx: 28.2335,
    cy: 82.9115,
    r: 2.62955,
    transform: "rotate(135 28.2335 82.9115)",
    fill: "#1E1E1E",
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-background-item",
    cx: 88.1572,
    cy: 67.5,
    r: 5,
    fill: "#1E1E1E",
    stroke: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-background-item",
    cx: 26.975,
    cy: 46.364,
    r: 3.55328,
    transform: "rotate(135 26.975 46.364)",
    fill: "#1E1E1E",
    stroke: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-background-item",
    cx: 65.6572,
    cy: 13,
    r: 2.5,
    fill: "#1E1E1E",
    stroke: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-background-item",
    cx: 58.6571,
    cy: 61.5858,
    r: 1.5,
    transform: "rotate(135 58.6571 61.5858)",
    fill: "#1E1E1E",
    stroke: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-background-item",
    cx: 49.4139,
    cy: 30.5858,
    r: 1.5,
    transform: "rotate(135 49.4139 30.5858)",
    fill: "#1E1E1E",
    stroke: "black"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-background-item",
    cx: 13.4139,
    cy: 96.5858,
    r: 1.5,
    transform: "rotate(135 13.4139 96.5858)",
    fill: "#1E1E1E",
    stroke: "black"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-background-item",
    cx: 69.078,
    cy: 78.1765,
    r: 1.5,
    transform: "rotate(-165 69.078 78.1765)",
    fill: "#1E1E1E",
    stroke: "black"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-background-item",
    cx: 91.3036,
    cy: 54.6721,
    r: 1.5,
    transform: "rotate(-165 91.3036 54.6721)",
    fill: "#1E1E1E",
    stroke: "black"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-background-item",
    cx: 16.1464,
    cy: 56.4952,
    r: 1.5,
    transform: "rotate(-165 16.1464 56.4952)",
    fill: "#1E1E1E",
    stroke: "black"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-background-item",
    cx: 19.4851,
    cy: 15.8284,
    r: 2.5,
    transform: "rotate(135 19.4851 15.8284)",
    fill: "#1E1E1E",
    stroke: "black"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-background-item",
    cx: 76.485,
    cy: 94.8284,
    r: 2.5,
    transform: "rotate(135 76.485 94.8284)",
    fill: "#1E1E1E",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-outline",
    d: "M30.6087 70.1806C31.3386 71.4447 31.8172 72.7602 32.0148 74.2379C32.172 75.6453 32.1481 77.0636 31.7623 78.5037C31.6732 78.836 31.5842 79.1683 31.4546 79.4304C31.236 80.0248 30.9768 80.549 30.6474 81.1137C30.4179 81.5271 30.1884 81.9405 29.9183 82.2837C29.7482 82.4756 29.5781 82.6674 29.4079 82.8593C29.0677 83.243 28.7274 83.6268 28.2763 83.9808C27.7551 84.3754 27.304 84.7294 26.7422 85.0538L21.2686 75.5732L15.7949 66.0925C16.3567 65.7682 16.8889 65.5546 17.4912 65.3004C17.9531 65.1274 18.5258 64.984 19.0283 64.8812C19.2795 64.8298 19.5307 64.7784 19.7819 64.727C20.2142 64.6647 20.6869 64.6727 21.1597 64.6806C21.8135 64.6777 22.397 64.7153 23.0211 64.8232C23.3534 64.9122 23.6452 64.9311 23.9775 65.0201C25.3473 65.4465 26.6578 66.0945 27.7981 66.9343C28.979 67.8443 29.8789 68.9165 30.6087 70.1806Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-outline",
    d: "M3.83342 42.9415L7.20431 40.9953C8.81953 40.0628 18.0412 44.1959 22.021 45.7372C22.6155 45.9558 25.7301 45.1876 27.6697 44.8168C28.4936 44.6221 29.4094 44.7488 30.1255 45.1781L36.1644 48.3396L17.8243 58.741L3.72847 44.2194C3.3042 43.8089 3.41206 43.1848 3.83342 42.9415Z",
    fill: "#1E1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-outline",
    d: "M92.5693 48.0783C92.6236 48.9833 92.5266 49.7883 92.3594 50.634C91.8172 53.1006 77.3454 62.5796 75.1684 63.8365L38.2399 85.3444L21.6162 56.5514L46.0552 42.4415C62.8561 34.2397 80.7035 37.4191 82.9486 37.902C83.0594 37.9316 83.2809 37.991 83.3917 38.0207C84.3589 38.3986 85.2857 38.7063 86.0719 39.095C90.9409 41.5276 92.4252 45.0715 92.5693 48.0783Z",
    fill: "#1E1E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-innerline",
    d: "M19.0282 64.8812L29.4485 82.9295C29.1082 83.3132 28.7679 83.697 28.3169 84.051L17.4912 65.3004C18.0233 65.0868 18.5258 64.984 19.0282 64.8812Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-innerline",
    d: "M23.6457 64.9309L31.7548 78.9763C31.5361 79.5707 31.277 80.0949 31.0178 80.6191L21.8545 64.7478C22.438 64.7854 23.0216 64.8231 23.6457 64.9309Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-outline",
    d: "M62.3175 71.2564L38.4838 85.7659L33.2939 76.7769C33.2939 76.7769 72.1795 58.8208 87.331 46.1403C87.331 46.1403 92.1385 50.5747 92.36 50.6341C92.36 50.6341 92.6584 54.3945 62.5687 71.205",
    fill: "#1E1E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-outline",
    d: "M32.9164 86.8267L57.5255 72.525L55.7952 76.9885C55.636 77.3613 48.176 82.6047 47.9356 82.8371L42.9887 90.0005C42.7187 90.3436 42.4486 90.6868 42.0273 90.9301C39.9017 92.4382 32.4605 97.3898 32.5387 96.8765L32.9164 86.8267Z",
    fill: "#1E1E1E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-innerline",
    d: "M38.5999 66.5038L36.0015 68.004C35.3694 68.3689 34.594 68.1612 34.2291 67.5291L33.5804 66.4055C33.2155 65.7735 33.4232 64.998 34.0553 64.6331L36.6537 63.1329C37.2857 62.768 38.0611 62.9758 38.426 63.6079L39.0748 64.7315C39.4397 65.3635 39.2319 66.1389 38.5999 66.5038Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-innerline",
    d: "M47.3782 61.4357L44.7798 62.9359C44.1477 63.3008 43.3723 63.093 43.0074 62.461L42.3587 61.3374C41.9938 60.7053 42.2015 59.9299 42.8336 59.565L45.432 58.0648C46.064 57.6999 46.8394 57.9077 47.2043 58.5397L47.8531 59.6634C48.218 60.2954 48.0102 61.0708 47.3782 61.4357Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-innerline",
    d: "M56.2258 56.327L53.6274 57.8271C52.9954 58.1921 52.22 57.9843 51.8551 57.3522L51.2063 56.2286C50.8414 55.5966 51.0492 54.8212 51.6812 54.4563L54.2796 52.9561C54.9117 52.5912 55.6871 52.7989 56.052 53.431L56.7007 54.5546C57.0656 55.1866 56.8579 55.962 56.2258 56.327Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-outline",
    d: "M92.57 48.0783C92.6243 48.9833 92.5273 49.7883 92.3601 50.634C90.3445 49.7377 88.5475 48.247 87.3716 46.2105C86.0742 43.9632 85.6709 41.4806 86.0726 39.095C90.9416 41.5276 92.4258 45.0715 92.57 48.0783Z",
    fill: "#1E1E1E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-innerline",
    d: "M65.7804 42.384C65.5668 41.8519 65.9773 41.4276 66.3878 41.0033C67.4897 39.9926 68.5373 38.0769 77.2231 39.3357C82.3563 40.1175 74.2802 44.7803 72.6353 45.8236C72.4246 45.9452 72.2436 45.9561 72.0626 45.9669C70.855 45.8214 67.0511 45.3958 65.7804 42.384Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpaceThumbnailContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SpaceThumbnail-contrast.addbf978caefcbd094f144f835559a82.svg";